module.exports = __webpack_public_path__ + "static/media/settings.3d3b337a.svg";